import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs'
import LazyLoad from 'react-lazyload';

import {Icon} from '@rmwc/icon'
import {Tooltip} from '@rmwc/tooltip'
import withSizes from 'react-sizes';
import { showToast } from '../services/toast';

import useUser from '../hooks/useUser';
import auth from '../services/auth';
import common from '../services/common';
import ga from '../services/ga';

import '../css/coin-card.css';

function AlertHistoryCard(props) {
  const [user] = useUser()
  const [inPortfolio, setInPortfolio] = useState(false)

  useEffect(() => {
    if (props.coin){
      setInPortfolio(user ? user.portfolio.includes(props.coin.coin) : false)
    }
  }, [props.coin]);

  return (
    <>
      {props.coin &&
        <div 
            className={`100-w p-2 hovered coin ${common.getBorderByAction(props.signal.signal).borderClass} ${(props.hideForFree) ? 'pro-coin' : ''}`}
            onClick={() => { 
              ga.track({
                category: 'Retention',
                action: 'onAlertHistoryCardSelected',
                label: props.coin.coin
              })
              props.onCoinSelected(props.coin.coin)}
            }>
            <div className="flex items-center gap-3">
                <div className="shrink-0">
                    {props.hideForFree &&
                        <img style={{width: 28+'px', filter: `blur(3px)`}} src={props.coin.image}/>
                    } 
                    {!props.hideForFree &&
                        <img style={{width: 28+'px'}} src={props.coin.image}/>
                    } 
                </div>
                <div className="min-w-0">
                    <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
                        <span className="">
                          {props.hideForFree &&
                            <b>PRO</b>
                          } 
                          {!props.hideForFree &&
                            <b>{props.coin.coin}</b>
                          } 
                        </span>
                        <span className="small text-muted hide-small">
                          {props.hideForFree && !props.isAlert &&
                            <b>Unlock PRO Access to Track This Coin</b>
                          } 
                          {props.hideForFree && props.isAlert &&
                            <b>Unlock PRO Access to Get This Alert</b>
                          } 
                          {!props.hideForFree &&
                            <b>{props.coin.name}</b>
                          } 
                        </span>
                        <span className="small text-muted rank">#{props.coin.rank}</span>
                    </div>
                    <div className="flex items-center">
                        <span className="small text-muted hide-small">Alert Price:&nbsp;</span>
                        <span className="small"><span className="text-muted">$</span>{props.signal.price ? props.signal.price.toFixed(3) : '-'}</span>&nbsp;
                    </div>
                </div>

                {!props.small &&
                  <div className="flex-1 hide-small text-left">
                    {props.hideForFree &&
                      <>
                      <LazyLoad style={{display: 'inline'}}>
                          <img onError={(e)=>{e.target.onerror = null; e.target.src="https://upload.wikimedia.org/wikipedia/commons/c/ca/1x1.png"}} title={`7 days ${props.coin.coin}/USDT price chart`} alt={`7 days PRO/USDT price chart`} style={{width: 150+'px', height: 40+'px', filter: `blur(3px)`}} src={`https://s3.coinmarketcap.com/generated/sparklines/web/7d/usd/${props.coin.cmc_id}.svg`}></img>
                      </LazyLoad>
                      {/*<img title={`7 days ${props.coin.coin}/USDT price chart`} alt={`7 days PRO/USDT price chart`} style={{width: 150+'px', filter: `blur(3px)`}} src={`https://images.cryptocompare.com/sparkchart/${props.coin.coin}/USD/latest.png`}></img>*/}

                      </>
                    }
                    {!props.hideForFree && !props.tv &&
                      <>
                        <div className="grid grid-cols-2 gap-3 items-center whitespace-nowrap">
                          <div className="flex items-center gap-2">
                            <LazyLoad style={{display: 'inline-block'}}>
                              <Tooltip content={`7 days ${props.coin.coin}/USDT price chart`}>
                                <img onError={(e)=>{e.target.onerror = null; e.target.src="https://upload.wikimedia.org/wikipedia/commons/c/ca/1x1.png"}} className={`${props.coin.change_7d >= 0 ? 'graph-up' : 'graph-down'}`} title={`7 days ${props.coin.coin}/USDT price chart`} alt={`7 days PRO/USDT price chart`} style={{width: 150+'px', height: 40+'px'}} src={`https://s3.coinmarketcap.com/generated/sparklines/web/7d/usd/${props.coin.cmc_id}.svg`}></img>
                              </Tooltip> 
                            </LazyLoad>
                            <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', whiteSpace: 'nowrap' }}>
                              <Icon className="text-muted" style={{fontSize: 10+'px'}} icon={{ icon: 'help'}}/>
                              <span className="text-muted small dashed">7d</span>
                            </span>
                          </div>
                          {/*<img title={`7 days ${props.coin.coin}/USDT price chart`} alt={`7 days PRO/USDT price chart`} style={{width: 150+'px'}} src={`https://images.cryptocompare.com/sparkchart/${props.coin.coin}/USD/latest.png`}></img>*/}
                          <div className="flex items-center gap-2">
                            <LazyLoad style={{display: 'inline-block'}}>
                              <Tooltip content={`30 days ${props.coin.coin}/USDT price chart`}>
                                <img onError={(e)=>{e.target.onerror = null; e.target.src="https://upload.wikimedia.org/wikipedia/commons/c/ca/1x1.png"}} className={`${props.coin.change_30d >= 0 ? 'graph-up' : 'graph-down'}`} title={`30 days ${props.coin.coin}/USDT price chart`} alt={`30 days PRO/USDT price chart`} style={{width: 150+'px', height: 40+'px'}} src={`https://s3.coinmarketcap.com/generated/sparklines/web/30d/usd/${props.coin.cmc_id}.svg`}></img>
                              </Tooltip> 
                            </LazyLoad>
                            <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', whiteSpace: 'nowrap' }}>
                              <Icon className="text-muted"  style={{fontSize: 10+'px'}} icon={{ icon: 'help'}}/>
                              <span className="text-muted small dashed">30d</span>
                            </span>
                          </div>
                        </div>
                      </>
                    }
                  </div>
                }

                {props.isAlert &&
                  <div className={`${props.isMobile ? 'pl-0' : ''} flex-1`}>
                      <div className="text-right mb-1 hide-small">
                              <Tooltip content="Relative Strength Index (RSI)">
                                <span className="text-muted small"> <Icon  className="hide-small" style={{fontSize: 10+'px'}} icon={{ icon: 'help'}}/> <span className="dashed">RSI</span>:</span>
                              </Tooltip>
                              <span className="ml-2 hide-small"><b>{props.signal.rsiNew.toFixed(2)}</b></span>
                              &nbsp;
                          <span className="text-muted small">Alert: </span>
                          <span className={`ml-1 font-weight-bold ${common.getColorByAction(props.signal.signal).alertClass}`}>{props.signal.signal}</span>
                      </div>

                      <div className="hide-large text-right">
                        <span className="text-muted rank">
                            {dayjs(props.signal.timestamp).format('DD.MM hh:mm a')}</span>
                      </div>
                      <div className="hide-large text-right">
                        <span className={`font-weight-bold small ${common.getColorByAction(props.signal.signal).alertClass}`}>{props.signal.signal}</span>
                      </div>
                      
                      <div className="text-right" >
                          {!props.small &&
                            <>
                              <span className="text-muted small hide-small">Date:</span>
                              <span className="ml-1 hide-small rank text-muted "><b>{dayjs(props.signal.timestamp).format('DD.MM.YYYY')}</b></span>
                              &nbsp;
                              <span className="ml-2 text-muted small hide-small">Time:</span>
                              <span className="ml-1 hide-small rank text-muted "><b>{dayjs(props.signal.timestamp).format('hh:mm a')}</b></span>
                            </>
                          }

                          <span className="ml-2 small hide-large"><b>{props.signal.rsiNew.toFixed(2)}</b></span>
                      </div>
                  </div>
                }
                <div className="shrink-0 p-1">
                    {props.hideForFree &&
                      <Icon icon="lock" style={{color: '#1d2238'}} />
                    }
                    {!props.hideForFree &&
                      <Tooltip content="Add/Remove From Portfolio">
                          <Icon icon="star" style={{color: (inPortfolio ? 'orange' : 'grey')}} onClick={(ev) => { 

                              if (!user.portfolio.includes(props.coin.coin)){
                                if (!auth.isProMembership() && user.portfolio.length >= 5){
                                  auth.showUnlockDialog();
                                  ev.stopPropagation();
                                  return;
                                }

                                setInPortfolio(true)
                                showToast(`Cool! Coin is added to your portfolio!`, 2000);
                                auth.addToPortfolio(props.coin.coin)
                              } else {
                                setInPortfolio(false)
                                showToast(`Ok, Coin is removed from your portfolio!`, 2000);
                                auth.removeFromPortfolio(props.coin.coin)
                              }
                              ev.stopPropagation()
                          }} />
                      </Tooltip>
                    }
                </div>
            </div>
        </div>
      }
    </>
  );
};

AlertHistoryCard.defaultProps = {
  isAlert: false,
  tv: false
};

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 480,
  isDesktop: width >= 1024
})

export default withSizes(mapSizesToProps)(AlertHistoryCard);
